/**
 * Extracts the file extension from a given filename.
 *
 * @param {string} filename - The name of the file.
 * @returns {string} The file extension in lowercase, or an empty string if none exists.
 */
export const getExtension = (filename: string): string => {
  const dot = filename.lastIndexOf('.');

  return dot === -1 ? '' : filename.slice(dot + 1).toLowerCase();
};
